module.exports = __webpack_public_path__ + "static/media/crop-icon.49987aa4.svg";